import { Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export const APP_RETURN_COPY = 'You can close this page and return to the I’d Tap That app.';

function AuthActionContinue({ continueTarget }) {
  if (continueTarget?.kind === 'continue' && continueTarget.href) {
    return (
      <Button
        component={Link}
        to={continueTarget.href}
        variant="contained"
        fullWidth
        sx={{ mt: 3 }}
      >
        Continue
      </Button>
    );
  }
  return (
    <Typography variant="body1" align="center" sx={{ mt: 3 }}>
      {APP_RETURN_COPY}
    </Typography>
  );
}

AuthActionContinue.propTypes = {
  continueTarget: PropTypes.shape({
    kind: PropTypes.string,
    href: PropTypes.string,
  }),
};

export default AuthActionContinue;
